import { select } from '@ps/web-core-store';
import { utils } from '@ps/web-poker-tile-mappers';
import type { ActiveGameDataTourney } from '@ps/web-poker-types';
import { Translation } from '@ps/web-shared-components';
import type React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import useTournamentTakeSeat from '../../hooks/takeSeat/useTournamentTakeSeat';
import useTournamentUnregister from '../../hooks/unregister/useTournamentUnregister';

import styles from './GameItem.module.scss';
import GameItemButtons from './GameItemButtons';
import sharedStyles from './shared.module.scss';
import { GAME_TYPE_TRANSLATIONS } from './utils/utils';

interface Props {
  game: ActiveGameDataTourney;
}

const GameItemTourney: React.FC<Props> = ({ game }) => {
  const unregister = useTournamentUnregister(+game.id);
  const takeSeat = useTournamentTakeSeat(+game.id);

  const { formatDate } = useIntl();

  const timeZoneName = useSelector(select.timeZone.getTimeZoneName);
  const { startTs } = utils.mttUtils.getMttStartTime({
    timeZone: timeZoneName,
    startTimestamp: game.startTime,
    lateRegTimestamp: 0
  });
  const startTimeMs = startTs * 1000;
  const formattedValue = formatDate(startTimeMs, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23'
  }).replace(',', '');

  return (
    <div className={styles.wrap}>
      <div className={styles.titleWrap}>
        <p className={styles.type}>
          <Translation {...GAME_TYPE_TRANSLATIONS[game.type]} />
        </p>
        <p className={styles.title}>
          {formattedValue && (
            <>
              <span className={sharedStyles.state}>{formattedValue}</span>
              <span className={sharedStyles.separator}>&nbsp;|&nbsp;</span>
            </>
          )}
          <span>{game.name}</span>
        </p>
      </div>
      <GameItemButtons game={game} onUnregister={unregister} onTakeSeat={takeSeat} />
    </div>
  );
};

export default GameItemTourney;
